import { useState } from "react";
import styled from "styled-components";

import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import { useToast } from "../../contexts/ToastContext";
import { useModal } from "../../contexts/ModalContext";
import { formatarData } from "../../Funcoes/FormatarData";
import { formatValorMoney } from "../../Funcoes/FormatValorMoney";
import useApi from "../../hooks/useApi";

const Titulo = styled.h2`
    margin: 0 0 10px 0;
    font-size: 17px;
    color: #263b4b;
    text-align: center;
`;

const Subtitulo = styled.p`
    margin: 0;
    font-size: 14px;
    color: #555;
    text-align: center;
    line-height: 1.5;
`;

const Resumo = styled.div`
    margin: 16px 0 0 0;
    padding: 12px;
    background-color: #f5f7fa;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 13px;
    color: #111;

    p {
        margin: 0;
    }

    b {
        color: #263b4b;
    }
`;

const BotoesWrapper = styled.div`
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

const Botao = styled.button`
    padding: 9px 16px;
    background-color: ${(p) => (p.$cancel ? "#e5e7eb" : "#e11d48")};
    color: ${(p) => (p.$cancel ? "#333" : "white")};
    border: none;
    border-radius: 6px;
    font-weight: 600;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover:not(:disabled) {
        background-color: ${(p) => (p.$cancel ? "#d1d5db" : "#be123c")};
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

const ModalDeleteFolga = ({ folga, fetchData }) => {
    const api = useApi();
    const { notifyError, notifySuccess } = useToast();
    const { closeModal } = useModal();
    const [removendo, setRemovendo] = useState(false);

    const handleDelete = async () => {
        if (!folga?.id || !folga?.matricula) return;

        setRemovendo(true);

        try {
            const { data } = await api.post("/Painel/API/Colaborador/DeleteFolga/", {
                id: folga.id,
                matricula: folga.matricula,
            });

            if (data?.success) {
                notifySuccess(data?.message || "Folga excluída com sucesso.");
                await fetchData();
                closeModal();
                return;
            }

            notifyError(data?.message || "Não foi possível excluir a folga.");
        } catch (err) {
            console.error(err);
            const msg = err?.response?.data?.message || "Erro ao excluir folga de campo.";
            notifyError(msg);
        } finally {
            setRemovendo(false);
        }
    };

    return (
        <Overlay state>
            <Modal size="sm">
                <Titulo>Confirmar exclusão</Titulo>
                <Subtitulo>Tem certeza que deseja excluir esta folga de campo?</Subtitulo>

                {folga && (
                    <Resumo>
                        <p><b>VALOR:</b> R$ {folga.valor ? formatValorMoney(folga.valor) : formatValorMoney("0.00")}</p>
                        <p><b>DATA:</b> {folga.data ? formatarData(folga.data) : "-"}</p>
                        <p><b>RETORNO:</b> {folga.data_retorno ? formatarData(folga.data_retorno) : "-"}</p>
                        <p><b>DIAS GOZO:</b> {folga.dias_gozo ?? "-"}</p>
                    </Resumo>
                )}

                <BotoesWrapper>
                    <Botao type="button" $cancel onClick={closeModal} disabled={removendo}>
                        CANCELAR
                    </Botao>
                    <Botao type="button" onClick={handleDelete} disabled={removendo}>
                        {removendo ? "EXCLUINDO…" : "EXCLUIR"}
                    </Botao>
                </BotoesWrapper>
            </Modal>
        </Overlay>
    );
};

export default ModalDeleteFolga;
